import React from 'react';
import StaffLayout from '../../components/StaffLayout';
import { PartnerNavigation } from '../../components/PartnerNavigation';
import { PartnerStats } from '../../components/PartnerStats';
import { PartnerReferrals } from '../../components/PartnerReferrals';
import { CommissionTable } from '../../components/CommissionTable';
import { useApi } from '../../lib/api';

export default function PartnerPage({ section = 'overview' }) {
  const { data, error, loading, reload } = useApi('/partner/dashboard');
  return <StaffLayout title="Partner Management"><div className="p-4 sm:p-6 space-y-6">
    <PartnerNavigation enabled={data?.enabled} />
    {error && <p data-testid="partner-page-error" role="alert" className="text-rose-700">{error}</p>}
    {loading && !data && <p data-testid="partner-page-loading">Loading…</p>}
    {data && <>
      {section !== 'overview' && <h1 data-testid="partner-section-heading" className="text-2xl font-semibold">{section === 'shops' ? 'My registered shops' : 'Commission history'}</h1>}
      {!data.enabled && <p data-testid="partner-registration-revoked" className="text-sm text-amber-800">New shop registration is disabled. Your referral and commission records remain available.</p>}
      {section === 'overview' && <><h1 data-testid="partner-account-heading" className="text-2xl font-semibold">Partner commission account · EUR</h1><PartnerStats data={data} /><p data-testid="partner-credit-policy" className="text-sm text-slate-500">Commission credit is separate from customer wallets. Pending commissions are not spendable credit.</p></>}
      {section === 'shops' && <PartnerReferrals rows={data.referrals} canInvite={data.enabled} onChanged={reload} />}
      {section === 'commissions' && <CommissionTable rows={data.commissions} />}
    </>}
  </div></StaffLayout>;
}